import AdminExportActions from "./AdminExportActions";
import { Button, Input, Select } from "../../ui";

export default function DocumentationFilters({ filters, onChange, onReset }) {
  const set = (key, value) => onChange({ ...filters, [key]: value });
  return (
    <div className="admin-filter-block">
      <div className="admin-panel-title">
        <h2>فلاتر سجل التوثيق</h2>
        <span>الفلاتر تطبق على السجل والتصدير</span>
      </div>
      <div className="admin-filters">
        <Input
          fullWidth={false}
          inputMode="numeric"
          placeholder="آخر 4 أرقام من الطلب"
          value={filters.last4 || ""}
          onChange={(e) =>
            set("last4", e.target.value.replace(/\D/g, "").slice(0, 4))
          }
        />
        <Select
          fullWidth={false}
          value={filters.documentationStatus || ""}
          onChange={(e) => set("documentationStatus", e.target.value)}
          placeholder="حالة التوثيق: الكل"
          options={[
            { value: "", label: "حالة التوثيق: الكل" },
            { value: "complete", label: "مكتمل" },
            { value: "pending", label: "قيد التوثيق" },
          ]}
        />
        <Select
          fullWidth={false}
          value={filters.outcome || ""}
          onChange={(e) => set("outcome", e.target.value)}
          placeholder="حالة الطلب: الكل"
          options={[
            { value: "", label: "حالة الطلب: الكل" },
            { value: "normal", label: "لا توجد حالة خاصة" },
            { value: "courierPickedUp", label: "استلم المندوب" },
            { value: "rejected", label: "مرفوض" },
            { value: "cancelled", label: "ملغي من التطبيق" },
            { value: "courierNotPickedUp", label: "لم يستلم المندوب" },
          ]}
        />
        <Select
          fullWidth={false}
          value={filters.matchStatus || ""}
          onChange={(e) => set("matchStatus", e.target.value)}
          placeholder="المطابقة مع تقرير الأخطاء: الكل"
          options={[
            { value: "", label: "المطابقة مع تقرير الأخطاء: الكل" },
            { value: "auto", label: "مطابق" },
            { value: "review", label: "يحتاج مراجعة" },
            { value: "missing", label: "غير موجود في تقرير الأخطاء" },
          ]}
        />
        <Select
          fullWidth={false}
          value={filters.sort || "createdAt_desc"}
          onChange={(e) => set("sort", e.target.value)}
          options={[
            { value: "createdAt_desc", label: "الأحدث إنشاءً" },
            { value: "createdAt_asc", label: "الأقدم إنشاءً" },
            { value: "businessDate_desc", label: "أحدث يوم عمل" },
            { value: "businessDate_asc", label: "أقدم يوم عمل" },
            { value: "last4_asc", label: "آخر 4 تصاعدي" },
            { value: "last4_desc", label: "آخر 4 تنازلي" },
          ]}
        />
      </div>
      <div className="admin-actions">
        <AdminExportActions filters={filters} />
        <Button
            variant="danger"
            appearance="soft"
            fullWidth={false}
          type="button"
          onClick={onReset}
        >
          مسح الفلاتر
        </Button>
      </div>
    </div>
  );
}
